import { Component, OnInit, ViewChild, Input, TemplateRef } from '@angular/core';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ValidationService } from '../../../shared/providers/validation.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { ToastService } from '../../../shared/providers/toast.service';

@Component({
  selector: 'app-duplicate-properties',
  templateUrl: './duplicate-properties.component.html',
  styleUrls: ['./duplicate-properties.component.css']
})
export class DuplicatePropertiesComponent implements OnInit {

  constructor(private router: Router, private Authentication: AuthenticationService, private _toastService: ToastService, protected loaderService: LoaderService,private modalService: BsModalService, private Loader: LoaderService, private validation: ValidationService, private propertyListingService: PropertyListingService) {

  }
  modalRefPropertyEditConfirmation: BsModalRef;
  modalRefRequestChange: BsModalRef;
  @Input() duplicatePropertyList: any[];
  @Input() modalRef: BsModalRef;
  currentProperty: any;
  requestedProperty: any;
  Comments: string;
  user: any;
  ngOnInit() {
    this.user = this.Authentication.user;
  }

  editProperty(prop) {
    if (this.Authentication.DataEntryStaff()) {
      if (prop.DEGuid) {
        this.validation.openLinkInNewTab('/dataentry-property/' + prop.DEGuid + '?merge=true');
      }
      else {
        this.Loader.display(true);
        this.propertyListingService.CopyPropertyToDE(prop.Id).subscribe(res => {
          this.Loader.display(false);
          this.validation.openLinkInNewTab('/dataentry-property/' + res + '?merge=true');
        });
      }
    }
    else if (this.Authentication.Admin() || this.Authentication.SuperAdmin()) {
      if (prop.Guid) {
        this.validation.openLinkInNewTab('/property/' + prop.Guid);
      }
      else if (prop.DEGuid) {
        this.validation.openLinkInNewTab('/dataentry-property/' + prop.DEGuid + '?merge=true');
      }
    }
  }

  onRequestChange(template: TemplateRef<any>, prop, classes: any) {
    this.requestedProperty = prop;
    this.modalRefRequestChange = this.modalService.show(template, { class: classes });
  }

  RequestEditToAdmin() {
    this.loaderService.display(true);
    const propertyDetails = {
      PropertyGuid: this.requestedProperty.Guid,
      LoggedInUserId: this.user.Id,
      Comments: this.Comments
    };

    this.propertyListingService.requestDuplicatePropertyEdit(propertyDetails).subscribe(response => {
      if (response) {
        this.Comments = "";
        this.loaderService.display(false);
        this.modalRefRequestChange.hide();
        this._toastService.addToast({ title: 'Success', msg: ' Request submitted successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
      }
      else {
        this.loaderService.display(false);
        this.modalRefRequestChange.hide();
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to submit request ', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    });
  }

  editPropertyConfirmation(template: TemplateRef<any>, prop) {
    if (this.Authentication.Admin() || this.Authentication.SuperAdmin()) {
      this.editProperty(prop);
    }
    if (this.Authentication.DataEntryStaff()) {
      if (prop.Is1031 != undefined && prop.Is1031) {
        if (prop.IsSameBrokerage != undefined && prop.IsSameBrokerage) {
          this.editProperty(prop);
        }
        else {
          this.currentProperty = prop;
          this.modalRefPropertyEditConfirmation = this.modalService.show(template, { class: 'deletemodal' });
        }
      }
    }
  }

  close() {
    this.modalRef.hide();
  }

  openLinkInNewTab(url: string) {
    window.open(url, "_blank");
  }
}

